import { SET_AI_NOTES_PANEL_VISIBLE } from '../ai-notes/actionTypes';
import { CLOSE_CHAT, OPEN_CHAT } from '../chat/actionTypes';
import { CUSTOM_PANEL_CLOSE, CUSTOM_PANEL_OPEN } from '../custom-panel/actionTypes';
import { PARTICIPANTS_PANE_CLOSE, PARTICIPANTS_PANE_OPEN } from '../participants-pane/actionTypes';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
// @ts-expect-error
import VideoLayout from '../../../modules/UI/videolayout/VideoLayout';
import { openSidePanelTab, removeSidePanelTab, bringFloatingSidePanelToFront } from './actions';
import { SidePanelTabId } from './constants';
import { isSidePanelTabFloating } from './functions';
import logger from './logger';
/**
 * Sync feature open/close actions into the unified side panel tab state.
 */
MiddlewareRegistry.register(({ dispatch, getState }) => next => action => {
    const result = next(action);
    switch (action.type) {
        case OPEN_CHAT: {
            const tabId = SidePanelTabId.CHAT;
            if (isSidePanelTabFloating(getState(), tabId)) {
                logger.info('聊天已在浮窗，置顶浮窗');
                dispatch(bringFloatingSidePanelToFront(tabId));
            }
            else {
                logger.info('打开聊天侧栏页签');
                dispatch(openSidePanelTab(tabId));
            }
            break;
        }
        case CLOSE_CHAT:
            logger.info('关闭聊天侧栏页签');
            dispatch(removeSidePanelTab(SidePanelTabId.CHAT));
            break;
        case PARTICIPANTS_PANE_OPEN: {
            const tabId = SidePanelTabId.PARTICIPANTS;
            if (isSidePanelTabFloating(getState(), tabId)) {
                logger.info('参会者已在浮窗，置顶浮窗');
                dispatch(bringFloatingSidePanelToFront(tabId));
            }
            else {
                logger.info('打开参会者侧栏页签');
                dispatch(openSidePanelTab(tabId));
            }
            break;
        }
        case PARTICIPANTS_PANE_CLOSE:
            logger.info('关闭参会者侧栏页签');
            dispatch(removeSidePanelTab(SidePanelTabId.PARTICIPANTS));
            break;
        case SET_AI_NOTES_PANEL_VISIBLE: {
            const tabId = SidePanelTabId.AI_NOTES;
            if (action.visible) {
                if (isSidePanelTabFloating(getState(), tabId)) {
                    logger.info('AI纪要已在浮窗，置顶浮窗');
                    dispatch(bringFloatingSidePanelToFront(tabId));
                }
                else {
                    logger.info('打开AI纪要侧栏页签');
                    dispatch(openSidePanelTab(tabId));
                }
            }
            else {
                logger.info('关闭AI纪要侧栏页签');
                dispatch(removeSidePanelTab(tabId));
            }
            break;
        }
        case CUSTOM_PANEL_OPEN: {
            const tabId = SidePanelTabId.CUSTOM_PANEL;
            if (isSidePanelTabFloating(getState(), tabId)) {
                logger.info('自定义面板已在浮窗，置顶浮窗');
                dispatch(bringFloatingSidePanelToFront(tabId));
            }
            else {
                logger.info('打开自定义面板侧栏页签');
                dispatch(openSidePanelTab(tabId));
            }
            break;
        }
        case CUSTOM_PANEL_CLOSE:
            logger.info('关闭自定义面板侧栏页签');
            dispatch(removeSidePanelTab(SidePanelTabId.CUSTOM_PANEL));
            break;
    }
    if ([
        OPEN_CHAT,
        CLOSE_CHAT,
        PARTICIPANTS_PANE_OPEN,
        PARTICIPANTS_PANE_CLOSE,
        SET_AI_NOTES_PANEL_VISIBLE,
        CUSTOM_PANEL_OPEN,
        CUSTOM_PANEL_CLOSE
    ].includes(action.type)) {
        try {
            VideoLayout?.onResize?.();
        }
        catch (error) {
            logger.debug('侧栏同步后刷新视频布局失败', { error });
        }
    }
    return result;
});
